import type { ReactNode } from "react";

/**
 * The frame every route sits in.
 *
 * `flex min-h-full flex-col gap-4 p-8` was the `<main>` of all six routes,
 * character for character, and `text-2xl font-semibold` was every `<h1>`.
 * The padding is now 24px on every side, the `--gutter` docs/design.md sets
 * for the 12-column field, so a route's left edge lines up with the grid
 * rather than sitting 8px outside it.
 */
export function PageLayout({
  title,
  meta,
  children,
}: {
  title: string;
  meta?: ReactNode;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-full flex-col gap-6 px-6 py-6">
      <header className="flex items-baseline justify-between gap-4 border-b-2 border-text pb-2">
        <h1 className="text-display-lg">{title}</h1>
        {meta ? <div className="text-label text-text-muted">{meta}</div> : null}
      </header>
      {children}
    </main>
  );
}
